export default {
    locationcd: '事業所',
    productno: '品名№',
    productname: '品名',
    date: '年月',
    newStock: '新品在庫',
    oldStock: '中古在庫'
};
